module.exports = __webpack_public_path__ + "static/img/6.a8544ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/common/medication/6.png
// module id = UWnT
// module chunks = 1